export default "__VITE_ASSET__Iuz5NfPz__"